import { CalendarService } from "./calendars.service";

export const calendarSerivce = new CalendarService();
